interface ProgressIndicatorProps { activeIndex: number; progress: number; labels: string[]; }

export function ProgressIndicator({ activeIndex, progress, labels }: ProgressIndicatorProps) {
  return (
    <div className="progress-stamps" aria-label={`Showing ${labels[activeIndex]}, panel ${activeIndex + 1} of ${labels.length}`}>
      {labels.map((label, index) => (
        <span key={label} className={index === activeIndex ? 'is-active' : index < activeIndex ? 'is-past' : ''} aria-hidden="true">
          <i style={index === activeIndex ? { transform: `scaleX(${progress})` } : undefined} />
          <b>{index + 1}</b>
        </span>
      ))}
    </div>
  );
}
